const Theme = () => {
  return localStorage.getItem('theme') || 'dark'
}

export default Theme
